import * as location from './location.js';
import * as alert from './alert.js';
import * as backup from './backup.js';
import * as sidebar from './sidebar.js';
import * as login from './login.js';
import * as common from './common.js';
import * as mydownloads from './my_downloads.js';
import * as jqueryHelpers from './jquery.custom-helpers';

export default {
    location,
    alert,
    backup,
    common,
    mydownloads,
    jqueryHelpers,
};

if (window.EQLAPP === undefined) {
    window.EQLAPP = {};
}

if (window.EQLAPP) {

    // Location
    window.EQLAPP.LOCATION = window.EQLAPP.LOCATION || {};
    Object.entries(location).forEach(([key, value]) => {
        window.EQLAPP.LOCATION[key] = value;
    });

    // Location
    window.EQLAPP.ALERT = window.EQLAPP.ALERT || {};
    Object.entries(alert).forEach(([key, value]) => {
        window.EQLAPP.ALERT[key] = value;
    });

    // Backup
    window.EQLAPP.BACKUP = window.EQLAPP.BACKUP || {};
    Object.entries(backup).forEach(([key, value]) => {
        window.EQLAPP.BACKUP[key] = value;
    });

    // Login
    window.EQLAPP.LOGIN = window.EQLAPP.LOGIN || {};
    Object.entries(login).forEach(([key, value]) => {
        window.EQLAPP.LOGIN[key] = value;
    });

    // Common
    window.EQLAPP.COMMON = window.EQLAPP.COMMON || {};
    Object.entries(common).forEach(([key, value]) => {
        window.EQLAPP.COMMON[key] = value;
    });

    // Sidebar
    window.EQLAPP.SIDEBAR = window.EQLAPP.SIDEBAR || {};
    Object.entries(sidebar).forEach(([key, value]) => {
        window.EQLAPP.SIDEBAR[key] = value;
    });

    // Tasks & Downloads
    window.EQLAPP.MYDOWNLOADS = window.EQLAPP.MYDOWNLOADS || {};
    Object.entries(mydownloads).forEach(([key, value]) => {
        window.EQLAPP.MYDOWNLOADS[key] = value;
    });

}